import { render, staticRenderFns } from "./InfinityList.vue?vue&type=template&id=1cd2ecff&scoped=true"
import script from "./InfinityList.vue?vue&type=script&lang=ts"
export * from "./InfinityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2ecff",
  null
  
)

export default component.exports